import React from "react";
import { Link, BrowserRouter, Routes, Route } from "react-router-dom";

const NavbarDesktop = () => {
  return (
    <>
      <div
        style={{
          display: "flex",
          // flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "2%",
          // border: "2px solid red",
          width: "90%",
          maxWidth: "90%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <h5
          style={{
            color: "white",
            fontFamily: "Fira Code, monospace",
            fontWeight: "bolder",
            // fontWeight: "bolder",
          }}
        >
          Mayowa
        </h5>
        <div style={{ textAlign: "right" }}>
          <ul>
            <li>
              <Link to="/" style={{ textDecoration: "none" }}>
                <span style={{ color: "#C778DD" }}>#</span>
                <span>home</span>
              </Link>
            </li>
            <li>
              <Link to="/works" style={{ textDecoration: "none" }}>
                <span style={{ color: "#C778DD" }}>#</span>
                <span>works</span>
              </Link>
            </li>
            <li>
              <Link to="/about" style={{ textDecoration: "none" }}>
                <span style={{ color: "#C778DD" }}>#</span>
                <span>about me</span>
              </Link>
            </li>
            <li>
              <Link to="/contacts" style={{ textDecoration: "none" }}>
                <span style={{ color: "#C778DD" }}>#</span>
                <span>contact</span>
              </Link>
            </li>
            {/* <li>En</li> */}
          </ul>
        </div>
      </div>
    </>
  );
};
export default NavbarDesktop;
